<template>
	<div class="md-grey-page center-horizontal">
		<div class="page-banner"></div>

		<div>
			<section class="container-white">
				<h1>Thank you!</h1>
				<p>You successfully accepted our <a href="https://bestagent.online/settings/conditions-of-use" target="_blank">Conditions of Use</a>.</p>
			</section>
		</div>

	</div>
</template>

<script>
import axios from 'axios';

export default {
  data: function() {
    return {
		 companyName: {}
    }
  },
  created: async function() {
	  let params = {
		  companyId: this.$route.params.companyId
	  };

	  axios.patch(`${this.config.services.companies}/accept-conditions`, params)
	  .then(function(response) {
		  console.log('ok');
	  })
	  .catch(function(error) {
		  console.error('error:', error);
	  });
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ConditionsOfUse-Accepted.vue